import { Box, List, ListItem, Typography } from '@mui/material';

import { Button } from '@/components';
import { urls } from '@/constants';
import { demo, gradientCheckmark } from '@/images';
import { selectUserRegion, useAppSelector } from '@/store';

const ListCheckmark = () => (
  <Box
    component="img"
    src={gradientCheckmark}
    sx={{ width: 24, height: 24, mr: 1.5 }}
  />
);

export const DemoPrompt = () => {
  const region = useAppSelector(selectUserRegion);
  return (
    <Box
      sx={theme => ({
        display: 'grid',
        gridTemplateColumns: { md: '1fr 1fr' },
        gap: { md: 8, xs: 2 },
        padding: 4,
        borderRadius: 4,
        background: theme.palette.gradients.primary,
      })}>
      <Box>
        <Box
          component="img"
          src={demo}
          sx={{
            width: '100%',
            maxWidth: 500,
            display: 'flex',
            justifySelf: 'flex-end',
          }}
        />
      </Box>
      <Box
        sx={{
          justifyContent: 'center',
          display: 'flex',
          flexDirection: 'column',
        }}>
        <Typography variant="h1" sx={{ mt: { md: 8 }, mb: 2, color: 'white' }}>
          Level Up Your Team
        </Typography>
        <Typography variant="body2" sx={{ mb: 2, color: 'white' }}>
          From professionalism fundamentals and soft skills to advanced
          financial concepts, our content covers a wide variety of topics so
          there&apos;s something for everyone.
        </Typography>
        <List disablePadding sx={{ pr: { md: 2 } }}>
          <ListItem disableGutters>
            <ListCheckmark />
            <Typography variant="body2" sx={{ color: 'white' }}>
              Organizational membership management
            </Typography>
          </ListItem>
          <ListItem disableGutters>
            <ListCheckmark />
            <Typography variant="body2" sx={{ color: 'white' }}>
              Trusted by leading firms and organizations
            </Typography>
          </ListItem>
          <ListItem disableGutters>
            <ListCheckmark />
            <Typography variant="body2" sx={{ color: 'white' }}>
              Your team will love our content
            </Typography>
          </ListItem>
        </List>
        <Box>
          <Button
            label="Book a Demo"
            variant="secondary"
            fullWidth={false}
            skinny={false}
            sx={{ mt: 6 }}
            onClick={() => window.open(urls.bookADemo[region], '_blank')}
          />
        </Box>
      </Box>
    </Box>
  );
};
